import type { ReactNode } from "react";

// The grapheme cards' mnemonic markup: `[_name_](glyph)` is a component (with its glyph, or `()`
// for none) and `[**meaning**](.)` is the character's own meaning.
const MNEMONIC_LINK_PATTERN = /\[(\*\*|_)(.+?)\1\]\((.*?)\)/;
const MNEMONIC_LINK_GROUP_COUNT = 3;

/**
 * A mnemonic story in the cards' own markup, styled like the app's lesson cards: components are
 * underlined with their glyph beside them and the meaning is bold, so the landing can quote real
 * stories verbatim.
 */
export function LandingMnemonicStoryText({ mnemonic }: { mnemonic: string }) {
  // Splitting on a pattern with capture groups yields the leading text, then one run of
  // (marker, name, glyph, following text) per link.
  const [leadingText, ...linkRuns] = mnemonic.split(MNEMONIC_LINK_PATTERN);
  const nodes: ReactNode[] = [leadingText];

  for (let index = 0; index < linkRuns.length; index += MNEMONIC_LINK_GROUP_COUNT + 1) {
    const [marker, name, glyph = "", followingText] = linkRuns.slice(
      index,
      index + MNEMONIC_LINK_GROUP_COUNT + 1,
    );
    nodes.push(
      marker === "**" ? (
        <strong className="font-semibold text-website-accent" key={index}>
          {name}
        </strong>
      ) : (
        <em className="underline decoration-current/30 underline-offset-[0.2em]" key={index}>
          {name}
          {glyph === "" ? null : (
            <span className="ml-1 not-italic" lang="zh-Hans">
              {glyph}
            </span>
          )}
        </em>
      ),
      followingText,
    );
  }

  return <>{nodes}</>;
}
